function initLoadMore() {
  const BATCH = 4;
  let visible = BATCH;
  let currentFilter = 'all';

  const getItems = () => [...document.querySelectorAll('.calendar__item')]
      .filter(el => currentFilter === 'all' || el.dataset.category
          .split(',')
          .map(c => c.trim().toLowerCase())
          .includes(currentFilter.toLowerCase()));

    function render() {
        const filtered = getItems();

        document.querySelectorAll('.calendar__item').forEach(el => {
            el.classList.add('calendar__item--hidden');
            el.classList.remove('calendar__item--fade');
        });

        filtered.slice(0, visible).forEach(el => {
            el.classList.remove('calendar__item--hidden');
            el.classList.add('calendar__item--fade');
        });

        const loadMore = document.querySelector('.load-more');
        if (loadMore) {
            loadMore.hidden = visible >= filtered.length;
        }
    }

    document.querySelectorAll('.calendar__filter-btn').forEach(btn => {
        btn.addEventListener('click', () => {
        document.querySelector('.calendar__filter-btn--active')?.classList.remove('calendar__filter-btn--active');
        btn.classList.add('calendar__filter-btn--active');
        currentFilter = btn.dataset.filter;
        visible = BATCH;
        render();
        });
    });

    const loadMoreBtn = document.querySelector('.calendar__load-more');
    if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
        visible += BATCH;
        render();
    });
    }

  render();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
} else {
    initLoadMore();
}
